export const formAnimalManagementNaming = {
  NEW_ANIMAL_MANAGEMENT_FORM: 'new-animal-management-form',
};
